import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Marker } from '@react-google-maps/api';
import {
    relocateMarkerDraftCoords,
    markerDraftMapControlSelector, markerDraftCoordsSelector,
    markerDraftColorSelector
} from '../../../features/places/placesSlice';
import { mdiMapMarkerRadius } from '@mdi/js';

const MarkerCreate = () => {

    const dispatch = useDispatch();
    const markerDraftMapControl = useSelector(markerDraftMapControlSelector);
    const markerDraftCoords = useSelector(markerDraftCoordsSelector);
    const markerDraftColor = useSelector(markerDraftColorSelector);

    const relocateVertex = (e) => {
        dispatch(relocateMarkerDraftCoords({
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
        }))
    }

    if (!markerDraftMapControl) {
        return null;
    } else {
        return (
            <div>
                {
                    markerDraftCoords.lat && markerDraftCoords.lng &&
                    <Marker
                        position={markerDraftCoords}
                        onClick={() => { }}
                        draggable={true}
                        onDragEnd={(e) => relocateVertex(e)}
                        icon={{
                            path: mdiMapMarkerRadius,
                            fillColor: markerDraftColor,
                            fillOpacity: 1,
                            anchor: new window.google.maps.Point(
                                10, // width
                                18 // height
                            ),
                            strokeWeight: 1,
                            strokeColor: markerDraftColor,
                            scale: 1,
                        }}
                    />
                }

            </div>
        );
    }


}

export default MarkerCreate;